import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

class CustomerList extends React.Component {
  state = {};
  constructor(props) { 
    super(props);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      userData: [] 
    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Marketing") {
      const url = process.env.REACT_APP_NODE_ENV + "/api/market-target-lead/list-all";
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
			// console.log(response)
          return response.json();
        }
      ).then(data => {		  
        this.setState({ userData: data })
      })
    }
  }

  triggerDelete = (id) => {
	  // alert(id)
	if(window.confirm("Are you sure you want to delete?")){
		const LeadData = {
		  id: id
		};
		fetch(process.env.REACT_APP_NODE_ENV + '/api/market-target-lead/delete', {
		method: 'POST',
		headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		},
		  body: JSON.stringify(LeadData)
		}).then(response => { if (response.ok) {
			this.componentDidMount()
		} }).then(data => console.log(data)).catch((err) => console.log(err))
	}
  };

// triggerDelete = (id)
  render() {
    // let userdatas = this.state.userData.map((data, index) => {
    //   return (
    //     <tr key={index}><td>{index + 1}</td><td>{data.id}</td>
    //       <td>{data.apartmentName}</td>
    //       <td>{data.apartmentPhoneNo}</td>
    //       <td>{data.doorNo + ", " + data.streetName + ", " + data.area}</td>
    //       <td> {data.city}</td>
    //       <td> {data.landmark}</td>
    //       <td><Button variant="outline-success" onClick={() => this.nextPath("/aprt-customer/customer-details", data.id)} >
    //         Details </Button></td></tr>)
    // });

    let dataArr = [];
	if(this.state.userData.length > 0){
    this.state.userData.map((data) => {
		let mdData = [
			data.Responsibility, data.Source, data.Category,data.Client_Name, data.Phone_number, data.Location,data.Status, data
		];
      dataArr.push(mdData)
      return null;
    });
	}


    const columns = [
		{
        name: "leadowner",
        label: "Lead Owner",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Source",
        label: "source",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "Category",
        label: "Category",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "ClientName",
        label: "Client Name",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "PhoneNumber",
        label: "Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "Location",
        label: "Location",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "Status",
        label: "Status",
        options: {
           filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
			  // console.log(value)
            return (
              <>
				
				{ (value === "Cold") && <Button variant="secondary">{value}</Button> }
				{ (value === "Warm") && <Button variant="warning">{value}</Button> }
				{ (value === "Hot") && <Button variant="primary">{value}</Button> }
				{ (value === "Converted") && <Button variant="success">{value}</Button> }
				{ (value === "Not Interested") && <Button variant="danger">{value}</Button> }
				
              </>
            );
          }
        }
      },	  
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
			  console.log(value)
             console.log(this.props.userId, Number(value.userId), this.props.userId ===  Number(value.userId) )
			if(this.props.userId === Number(value.userId)) {
             return ( 
				<>
					<Tooltip title="View"><IconButton onClick={() => window.open("/market-target-lead/customer-view?id="+value.id, "_blank")}><VisibilityIcon /></IconButton></Tooltip>
					<Tooltip title="Edit"><IconButton onClick={() => window.open("/market-target-lead/customer-edit?id="+value.id, "_blank")}><EditIcon /></IconButton></Tooltip>
					<Tooltip title="Delete"><IconButton onClick={() => this.triggerDelete(value.id)}><DeleteForeverIcon /></IconButton></Tooltip>
              </>);
			} else {
				return (  <>
					<Tooltip title="View"><IconButton onClick={() => window.open("/market-target-lead/customer-view?id="+value.id, "_blank")}><VisibilityIcon /></IconButton></Tooltip>
              </>  );
			}
           
          }
        }
      }
    ];


    const options = {
     filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'All Leads.csv',
      },
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Marketing") {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>All Leads</Breadcrumb.Item>
          </Breadcrumb>

        <div style={{ marginTop: "10px" }}>
            <MUIDataTable
              title={"All Leads"}
              data={dataArr}
              columns={columns}
              options={options} 
			/>
        </div>
		
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(CustomerList)
